import React, { useState, useEffect } from 'react';
import { authProvider } from '../../../services/Security';
import { CircularProgress, Grid, Tab, Tabs } from '@material-ui/core';
import '../../../scss/UVP.scss';
import { ReportCriteria } from './ReportCriteria';
import { PaymentReportList } from './PaymentReportList';
import { DistrictInfoVService, PortalConfigsVService } from '../../../services/V2/padre';

export const ReportTabs = ({ errorToast, successToast }) => {
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [operatorId, setOperatorId] = useState<any>();
    const [districtId, setDistrictId] = useState<any>();
    const [model, setModel] = useState()
    const [districtName, setDistrictName] = useState<any>("");
    const [loading, setLoading] = useState<boolean>(true);
    const [offsetInMinutes, setOffsetInMinutes] = useState<number>(-new Date().getTimezoneOffset());

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data) {
                const data = JSON.parse(event.data);
                authProvider.setToken(data?.token);
                setOperatorId(data.operatorId);
                setDistrictId(data.districtId);
                setLoading(false)
            }
        };

        window.addEventListener('message', handleMessage);
      
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    useEffect(() => {
        if (operatorId) {
            PortalConfigsVService.portalConfigsVGetAll(operatorId)
                .then((x: any) => {
                    let offset: number = -new Date().getTimezoneOffset();
                    try {
                        const nowDate = new Date();
                        const utcString = nowDate.toLocaleString('en-US', { timeZone: 'UTC' });
                        const tzString = nowDate.toLocaleString('en-US', { timeZone: x.timezone });
                        const utcDate = new Date(utcString);
                        const tzDate = new Date(tzString);
                        offset = Math.round((tzDate.getTime() - utcDate.getTime()) / 60000);
                    } catch (e) {
                    }
                    setOffsetInMinutes(offset);
                })
                .catch((x) => { });
        }
    }, [operatorId]);

    useEffect(() => {
        setLoading(true)
        DistrictInfoVService.districtInfoVGetDistrictInfo(districtId)
		.then((x: any) => {
			setDistrictName(x.name);
            setLoading(false)
		})
		.catch((x) => { });
	}, 	[districtId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (tab: number) => {
        setSelectedTab(tab);
    };

    return (
        <React.Fragment>
            <Grid style={{ backgroundColor: 'white' }}>
                <Tabs
                    className='uvp-tab-bar'
                    style={{ backgroundColor: '#f5f5f5' }}
                    value={selectedTab}
                    onChange={(_, tab) => handleChange(tab)}
                    TabIndicatorProps={{ style: { background: '#3f8a3d', height: "4px" } }}>
                    <Tab
                        className='uvp-tabs'
                        label="Report Criteria"
                        style={{
                            backgroundColor: selectedTab === 0 ? 'white' : '#E0E0E0'
                        }} />
                    <Tab
                        className='uvp-tabs'
                        label="Output"
                        style={{
                            backgroundColor: selectedTab === 1 ? 'white' : '#E0E0E0'
                        }} />
                </Tabs>
                {selectedTab === 0 ?
                    <ReportCriteria
                        model={model}
                        operatorId={operatorId}
                        districtId={districtId}
                        districtName={districtName}
                        submit={() => handleChange(1)}
                        setModel={setModel} 
                        errorToast={errorToast}
                        setLoading={setLoading}
                        loading={loading} /> :
                    <PaymentReportList
                        successToast={successToast}
                        model={model}
                        errorToast={errorToast}
                        operatorId={operatorId}
                        offsetInMinutes={offsetInMinutes} />
                }
                {loading && 
                    <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                }
            </Grid>
        </React.Fragment>
    );
};
